import * as React from 'react';
import { css } from '@emotion/core';
import styled from '@emotion/styled';

import { fontSize, space, width } from 'styled-system';
import { ChevronRight } from 'react-feather';

const BreadcrumbWrapper = styled('nav')(
  () => css`
    ol {
      list-style: none;
      display: flex;
      align-items: flex-start;
      flex-wrap: wrap;
      margin: 0;
      padding: 0;
    }

    li {
      display: flex;
    }
  `,
  fontSize,
  space,
  width
);

const StyledChevronRight = styled(ChevronRight)(
  ({ theme }) => css`
    color: ${theme.colors.charcoal};
    margin: auto ${theme.space.xxs} auto ${theme.space.xxs};
  `
);

export default function Breadcrumb(props) {
  const { children, ...navProps } = props;
  const childrenArray = React.Children.toArray(props.children);
  return (
    <BreadcrumbWrapper {...navProps} aria-label="breadcrumbs">
      <ol itemScope itemType="https://schema.org/BreadcrumbList">
        {childrenArray.map((child, i, arr) => (
          // eslint-disable-next-line react/no-array-index-key
          <li key={i} itemProp="itemListElement" itemScope itemType="https://schema.org/ListItem">
            {child}
            {i !== arr.length - 1 && <StyledChevronRight size="1em" />}
          </li>
        ))}
      </ol>
    </BreadcrumbWrapper>
  );
}

Breadcrumb.defaultProps = {
  children: undefined,
  fontSize: 'sm',
};
